import { useIntl } from 'react-intl';

export function useTranslation() {
  const intl = useIntl();

  const t = (key: string, defaultMessage?: string) => {
    return intl.formatMessage({
      id: key,
      defaultMessage: defaultMessage || key
    });
  };

  return t;
}
